module.exports = __webpack_public_path__ + "2c08f2a806c1e85d978394497630264e.pdf";